import { AvailablePlansTypes } from '@constants/plans'
import { useGetPlanCTAButton } from '@pages/Checkout/hooks/useGetCTAButton'
import { Icon, Paragraph, Spreader } from '@ui-kit'
import { FC } from 'react'
import { Trans } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from './CTAButton.module.scss'

interface CTAButtonProps {
  recordKey: AvailablePlansTypes
  isFreePlan?: boolean
  isOldPlan?: boolean
}

const CurrentFreePlan = () => (
  <Row className={styles['cta-button__current-free']} vertical='center'>
    <Column justifyContent='center'>
      <Icon icon='icon-check-circle' size={20} />
    </Column>

    <Spreader spread={10} />

    <Paragraph lineHeight='normal'>
      <Trans i18nKey='change.plan.page.current.plan' />
    </Paragraph>
  </Row>
)

export const CTAButton: FC<CTAButtonProps> = ({
  recordKey,
  isFreePlan,
  isOldPlan
}) => {
  const ctaButton = useGetPlanCTAButton({ recordKey, isOldPlan })

  return isFreePlan ? <CurrentFreePlan /> : ctaButton
}

CTAButton.displayName = 'CheckoutPlansPlanPanelsPlanCTAButton'
